import React from 'react';
import styled from 'styled-components';

import Button from 'components/presenters/button/Button';

export default function OrderInvoiceButton({ onClick }) {
  return <InvoiceButton onClick={onClick} fullwidth>확인</InvoiceButton>
}

const InvoiceButton = styled(Button)`
  flex: 0 1 auto;
  position: absolute;
  bottom: 0;
  background: #FFCF19;
  margin-right: calc(100vw * (-17 / 375));
  margin-left: calc(100vw * (-17 / 375));
  padding: calc(100vw * (23 / 375)) 0;
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (26.06 / 375));
`;
